import React from "react"
import Navigation from "../navigation"
import styles from "./teleworkheader.module.css"
import header from "./Telework_614.png"

const TeleworkHeader = (props) => {

    return (
        <div className={styles.container}>
            <Navigation 
                type="horizontal"
                items={[
                    {
                        title: "Upcoming Sessions",
                        url: "/#events",
                    },
                    {
                        title: "On-Demand Sessions",
                        url: "/on-demand",
                    },
                    
                    
                ]}
            />
            <img src={header} alt="SNG Live Telework" className="deskHead" width="100%"/>
            <img src={header} alt="SNG Live Telework" className="mobHead" width="100%"/>
            <div className={styles.hideme}>
                <h1 className={styles.title}>{props.title}</h1>
                <h1 className={styles.subTitle}>{props.subTitle}</h1>
                
            </div>
            
        </div>
    )
}

TeleworkHeader.defaultProps = {
    title: `SNG Live - Telework`,
    subTitle: `2020`
}
export default TeleworkHeader